import {cloneDeep} from 'lodash';

import {
  VISUALIZER_MANAGEMENT_REQUEST,
  VISUALIZER_MANAGEMENT_SUCCESS,
  VISUALIZER_MANAGEMENT_UPDATE_REQUEST,
  VISUALIZER_MANAGEMENT_CHANGES_SAVED,
  VISUALIZER_MANAGEMENT_UPDATE_DELETE_LIST,
  VISUALIZER_MANAGEMENT_DEFAULTS_REQUEST,
  VISUALIZER_MANAGEMENT_DEFAULTS_SUCCESS,
  VISUALIZER_MANAGEMENT_GET_DEFAULTS,
  VISUALIZER_MANAGEMENT_SET_DEFAULTS,
  VISUALIZER_MANAGEMENT_POST_DEFAULTS,
  VISUALIZER_MANAGEMENT_SET_ACTIVE_DEFAULT_PRESET_INDEX,
  VISUALIZER_MANAGEMENT_SET_ACTIVE_TAB,
  VISUALIZER_MANAGEMENT_SET_PRODUCT_JOURNEY, VISUALIZER_MANAGEMENT_SET_PRESETS_RECEIVED
} from '../../constants/actionTypes';
import {VISUALIZER_TYPES} from "../../constants/dashboard";

const initialState = {
  presetsReceived: false,
  loading: false,
  activeTab: "",
  initialLoaded: [],
  mobileMenu: [],
  mobileBVMenu: [],
  mobileFpMenu: [],
  mobileLrMenu: [],
  delete: [],
  defaultBvPresets: [],
  defaultKvPresets: [],
  defaultFpPresets: [],
  defaultLrPresets: [],
  maxKvPresetId: 0,
  maxBvPresetId: 0,
  activeDefaultBvPresetIndex: 0,
  activeDefaultKvPresetIndex: 0,
  activeDefaultFpPresetIndex: 0,
  activeDefaultLrPresetIndex: 0,
  isProductJourney: false,
};

// DO not use the spread operator for Arrays, because we have an array of objects
// which leads to a shalow copy of the objects

const getForToolPayload = (forTool, payload) => {
  return cloneDeep(payload.filter(p => p.forTool === forTool))
}

export default function sites(state = initialState, action) {
  switch (action.type) {
    case VISUALIZER_MANAGEMENT_REQUEST:
      return {...state, loading: true, statusUpdateSuccess: false};
    case VISUALIZER_MANAGEMENT_SUCCESS:
      return {
        ...state,
        mobileMenu: getForToolPayload(VISUALIZER_TYPES.kitchen, action.payload),
        mobileBVMenu: getForToolPayload(VISUALIZER_TYPES.bathroom, action.payload),
        mobileFpMenu: getForToolPayload(VISUALIZER_TYPES.fireplace, action.payload),
        mobileLrMenu: getForToolPayload(VISUALIZER_TYPES.laundryroom, action.payload),
        initialLoaded: cloneDeep(action.payload)
      };
    case VISUALIZER_MANAGEMENT_UPDATE_REQUEST:
      switch (action.payload.forTool) {
        case VISUALIZER_TYPES.bathroom:
          return {...state, mobileBVMenu: cloneDeep(action.payload.mobileMenu)};
        case VISUALIZER_TYPES.kitchen:
          return {...state, mobileMenu: cloneDeep(action.payload.mobileMenu)};
        case VISUALIZER_TYPES.fireplace:
          return {...state, mobileFpMenu: cloneDeep(action.payload.mobileMenu)};
        case VISUALIZER_TYPES.laundryroom:
          return {...state, mobileLrMenu: cloneDeep(action.payload.mobileMenu)};
        default:
          break;
      }
      return state
    case VISUALIZER_MANAGEMENT_CHANGES_SAVED:
      return {...state, delete: []};
    case VISUALIZER_MANAGEMENT_UPDATE_DELETE_LIST:
      return {...state, delete: cloneDeep([...state.delete, action.payload])};
    case VISUALIZER_MANAGEMENT_DEFAULTS_REQUEST:
      return {...state, loading: true};
    case VISUALIZER_MANAGEMENT_DEFAULTS_SUCCESS:
      return {...state, loading: false};
    case VISUALIZER_MANAGEMENT_GET_DEFAULTS:
    case VISUALIZER_MANAGEMENT_SET_DEFAULTS:
    case VISUALIZER_MANAGEMENT_POST_DEFAULTS:
    case VISUALIZER_MANAGEMENT_SET_ACTIVE_DEFAULT_PRESET_INDEX:
    case VISUALIZER_MANAGEMENT_SET_ACTIVE_TAB:
    case VISUALIZER_MANAGEMENT_SET_PRODUCT_JOURNEY:
    case VISUALIZER_MANAGEMENT_SET_PRESETS_RECEIVED:
      // console.log('action.payload', action.payload);
      return {...state, ...action.payload};
    default:
      return state;
  }
}
